// 회사 정보 API

import HTTP from 'apiDefault'

// 회사 정보 상세
export const get = (accountID, companyID) => {
  return HTTP.get(`/company/${accountID}/detail/${companyID}`
    , { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 회사 추가
export const add = (accountID, data) => {
  return HTTP.post(`/company/${accountID}/add`,
    data,
    { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 회사 수정
export const update = (accountID, companyID, data, watermarkFile, loginFile) => {

  let f = new FormData()

  for (let p in data) {
    f.set(p, data[p])
    console.log(p, data[p])
  }
  if (watermarkFile) {
    f.append('watermark_file', watermarkFile)
  }

  if (loginFile) {
    f.append('login_file', loginFile)
  }

  return HTTP.post(`/company/${accountID}/update/${companyID}`,
    f,
    { headers: { Authorization: window._VUE_STATE.header } },
  )
}

// 회사 목록
export const list = (accountID, page, pageSize) => {
  if (!pageSize) {
    pageSize = 25
  }
  if (!page) {
    page = 0
  }
  return HTTP.get(`/company/${accountID}/list?page=${page}&size=${pageSize}`,
    { headers: { Authorization: window._VUE_STATE.header } },
  )
}



// WEBPACK FOOTER //
// ./src/api/company.js